import React from 'react';
import { withStyles } from '@material-ui/core'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

const StyledTextField = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
    '& input': {
      fontSize: 16,
    },
    '& input::placeholder': {
      textAlign: 'left',
      fontStyle: 'italic',
    },
  },
}))(TextField)

export default function CustomTextField({
  size = 'contained',
  margin = 'dense',
  variant = 'outlined',
  ...props
}) {
  return (
    <Field
      component={StyledTextField}
      size={size}
      margin={margin}
      variant={variant}
      fullWidth
      {...props}
    />
  )
}
